module.exports = __webpack_public_path__ + "img/portrait_5_1.47753206.jpeg";